import { useSubscriptionAccess } from '../hooks/useSubscriptionAccess'
import { useAppSelector } from '../hooks/reduxToolkit'
import { Link } from 'react-router'
import { useTerminology } from '../hooks/useTerminology'

/**
 * Displays a banner when the user's subscription has expired or is missing.
 * Provides a link to manage subscription.
 */
export function SubscriptionBanner() {
  const { isReadOnly } = useSubscriptionAccess()
  const organization = useAppSelector(state => state.membership.organization)
  const terms = useTerminology()

  // isReadOnly is the server's verdict (see isSubscriptionReadOnly), and whether an
  // organization covers this member is already part of it -- re-checking the org here
  // only ever suppressed a banner the server had already said was warranted. The org
  // state now decides the wording and nothing else.
  if (!isReadOnly) {
    return null
  }

  const hasLapsedOrgSubscription = organization && organization.subscription_end_date &&
    new Date(organization.subscription_end_date) <= new Date()

  return <div className="alert alert-warning mb-3">
    <strong>{hasLapsedOrgSubscription ? "Your organization's subscription has expired." : "Your subscription has expired."}</strong>{' '}
    You can still view your data, close {terms.incidents}, and delete expenses,
    but you cannot add new expenses or create new {terms.incidents}.{' '}
    <ResubscribeLink />
  </div>
}

export function ResubscribeLink() {
  return <Link to="/subscription" className="btn btn-link p-0">
    Manage subscription
  </Link>
}
